import apiClient from '../utils/apiClient';

export const getTasks = async (today) => (await apiClient.get('api/tasks', { params: { today } })).data;

export const getOverdueTaskCount = async (today) => (await apiClient.get('api/tasks/overdue-count', { params: { today } })).data.count || 0;

export const getSeriesHistory = async (seriesId) => (await apiClient.get(`api/tasks/series/${seriesId}/tasks`)).data.tasks;

export const createTask = async (task) => (await apiClient.post('api/tasks', task)).data.task;

export const updateTask = async (id, task) => (await apiClient.put(`api/tasks/${id}`, task)).data.task;

export const deleteTask = async (id) => (await apiClient.delete(`api/tasks/${id}`)).data;

// { ids, patch } or { restore, created }: see the batch endpoint.
export const batchUpdateTasks = async (body) => (await apiClient.patch('api/tasks/batch', body)).data;

export const batchDeleteTasks = async (ids) => (await apiClient.post('api/tasks/batch-delete', { ids })).data;

export const setSubtaskDone = async (taskId, subtaskId, done) => (await apiClient.patch(`api/tasks/${taskId}/subtasks/${subtaskId}`, { done })).data.subtask;

export const setSeriesActive = async (seriesId, active, today) => (await apiClient.patch(`api/tasks/series/${seriesId}`, { active, today })).data.series;

// Settings > Task Categories, managed with the shared ordered-list endpoints.
export const getTaskCategories = async () => (await apiClient.get('api/tasks/categories')).data.categories;
export const createTaskCategory = async (category) => (await apiClient.post('api/tasks/categories', category)).data.category;
export const updateTaskCategory = async (id, category) => (await apiClient.put(`api/tasks/categories/${id}`, category)).data.category;
export const deleteTaskCategory = async (id) => (await apiClient.delete(`api/tasks/categories/${id}`)).data;
export const reorderTaskCategories = async (ids) => (await apiClient.put('api/tasks/categories/reorder', { ids })).data.categories;
